import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export class ObservableHelper {
  private constructor() {}

  static untilFirstNonNull<T>(source: Observable<T>) {
    return this.untilFirstSatisfying(source, e => e != null);
  }

  static untilFirstSatisfying<T>(
    source: Observable<T>,
    predicate: (e: T) => boolean
  ) {
    return source.pipe(
      filter(predicate),
      take(1)
    );
  }
}
